import { loggedInUser, menuItemSet } from "src/types";
import { Auth } from "../auth";

import "./style.scss";
import { Icon } from "../../lib/icons";

interface Props {
  links: menuItemSet;
  currentUser?: loggedInUser;
}

export const Footer = ({ links, currentUser }: Props) => {
  return (
    <footer class="footer hide-if-top-level">
      <div class="footer">
        <div class="twocolumn">
          <h2>Contact Us</h2>
          <p>
            <b>Want to find out more?</b>
            <br />
            Give us a call on <a href="tel:+61413312583">
              0413 312 583
            </a> or{" "}
            <a href="mailto:info@ceroc-adelaide.com.au">send us an email!</a>
          </p>
        </div>
        <div class="twocolumn">
          <p>
            <b>Want to start dancing now?</b>
            <br />
            Just come to one of our classes.
            <br /> There's no need to book, and there are plenty of people
            waiting to dance with you!
          </p>
          <div style={{ display: "flex" }}>
            <span>
              <a
                href="https://www.facebook.com/ceroc/"
                target="_blank"
                title="Ceroc &amp; Modern Jive Adelaide"
              >
                <Icon
                  name="FacebookIcon"
                  style={{
                    color: "#0066FF",
                    fontSize: "3em",
                    margin: "-0.1em 0.1em 0 -0.15em",
                  }}
                />
              </a>
            </span>
            <span>
              Like the{" "}
              <a href="https://www.facebook.com/ceroc/" target="_blank">
                <b>Ceroc &amp; Modern Jive Adelaide</b> page on Facebook
              </a>{" "}
              and{" "}
              <a
                href="https://www.instagram.com/ceroc_modernjive_adelaide/"
                target="_blank"
              >
                follow us on Instagram
              </a>{" "}
              to keep in touch with the latest news and events!
            </span>
          </div>
        </div>
      </div>
      <nav class="nonmobile">
        {links?.map(
          (link) => "url" in link && <a href={link.url}>{link.label}</a>
        )}
        <Auth currentUser={currentUser} />
      </nav>
    </footer>
  );
};
